// components/InfoButton.jsx
import React, { useState, useRef } from "react";
import {
	useFloating,
	autoUpdate,
	offset,
	flip,
	shift,
	useClick,
	useDismiss,
	useRole,
	useInteractions,
	FloatingPortal,
	arrow,
} from "@floating-ui/react";
import "../styling/Tooltip.css";

export default function InfoButton({
	label,
	content,
	placement = "top",
	className = "",
}) {
	const [isOpen, setIsOpen] = useState(false);
	const arrowRef = useRef(null);

	const { refs, floatingStyles, context, middlewareData } = useFloating({
		open: isOpen,
		onOpenChange: setIsOpen,
		placement,
		whileElementsMounted: autoUpdate,
		middleware: [
			offset(8),
			flip({ fallbackPlacements: ["bottom", "left", "right"] }),
			shift({ padding: 8 }),
			arrow({ element: arrowRef }),
		],
	});

	const click = useClick(context, {
		event: "click",
		toggle: true,
	});

	const dismiss = useDismiss(context, {
		outsidePress: true,
		escapeKey: true,
	});

	const role = useRole(context, { role: "dialog" });

	const { getReferenceProps, getFloatingProps } = useInteractions([
		click,
		dismiss,
		role,
	]);

	const side = context.placement?.split("-")[0] || "top";
	const arrowSide = {
		top: "bottom",
		bottom: "top",
		left: "right",
		right: "left",
	}[side];

	return (
		<>
			<button
				ref={refs.setReference}
				type="button"
				className={`info-trigger-button ${className}`}
				{...getReferenceProps()}
			>
				{label}
			</button>

			{isOpen && content && (
				<FloatingPortal>
					<div
						ref={refs.setFloating}
						style={floatingStyles}
						className="tooltip-box"
						{...getFloatingProps()}
					>
						{content}
						<div
							ref={arrowRef}
							className="tooltip-arrow"
							style={{
								left: middlewareData.arrow?.x ?? "",
								top: middlewareData.arrow?.y ?? "",
								[arrowSide]: -4,
							}}
						/>
					</div>
				</FloatingPortal>
			)}
		</>
	);
}